import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "editor-toolbar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "editor-uploading"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "tiptap-editor",
    onDragover: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6], (level) => {
        return _createElementVNode("button", {
          key: level,
          type: "button",
          class: _normalizeClass({active:$setup.editor.isActive('heading',{level})}),
          onClick: $event => ($setup.editor.chain().focus().toggleHeading({level}).run())
        }, "H" + _toDisplayString(level), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
      }), 64 /* STABLE_FRAGMENT */)),
      _cache[17] || (_cache[17] = _createElementVNode("span", null, null, -1 /* CACHED */)),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass({active:$setup.editor.isActive('bold')}),
        onClick: _cache[0] || (_cache[0] = $event => ($setup.editor.chain().focus().toggleBold().run()))
      }, [...(_cache[13] || (_cache[13] = [
        _createElementVNode("b", null, "B", -1 /* CACHED */)
      ]))], 2 /* CLASS */),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass({active:$setup.editor.isActive('italic')}),
        onClick: _cache[1] || (_cache[1] = $event => ($setup.editor.chain().focus().toggleItalic().run()))
      }, [...(_cache[14] || (_cache[14] = [
        _createElementVNode("i", null, "I", -1 /* CACHED */)
      ]))], 2 /* CLASS */),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass({active:$setup.editor.isActive('underline')}),
        onClick: _cache[2] || (_cache[2] = $event => ($setup.editor.chain().focus().toggleUnderline().run()))
      }, [...(_cache[15] || (_cache[15] = [
        _createElementVNode("u", null, "U", -1 /* CACHED */)
      ]))], 2 /* CLASS */),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass({active:$setup.editor.isActive('strike')}),
        onClick: _cache[3] || (_cache[3] = $event => ($setup.editor.chain().focus().toggleStrike().run()))
      }, [...(_cache[16] || (_cache[16] = [
        _createElementVNode("s", null, "S", -1 /* CACHED */)
      ]))], 2 /* CLASS */),
      _cache[18] || (_cache[18] = _createElementVNode("span", null, null, -1 /* CACHED */)),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = $event => ($setup.editor.chain().focus().toggleBulletList().run()))
      }, "• List"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[5] || (_cache[5] = $event => ($setup.editor.chain().focus().toggleOrderedList().run()))
      }, "1. List"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[6] || (_cache[6] = $event => ($setup.editor.chain().focus().toggleBlockquote().run()))
      }, "❝"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[7] || (_cache[7] = $event => ($setup.editor.chain().focus().toggleCodeBlock().run()))
      }, "</>"),
      _createElementVNode("button", {
        type: "button",
        onClick: $setup.setLink
      }, "🔗"),
      _createElementVNode("button", {
        type: "button",
        onClick: $setup.chooseFiles
      }, "📎")
    ]),
    _createElementVNode("div", {
      class: "editor-content-wrap",
      onClick: $setup.openImage
    }, [
      _createVNode($setup["EditorContent"], { editor: $setup.editor }, null, 8 /* PROPS */, ["editor"]),
      ($setup.uploading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Загрузка файлов: " + _toDisplayString($setup.uploading), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.lightbox.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-lightbox",
          onClick: _cache[11] || (_cache[11] = _withModifiers($event => ($setup.lightbox=[]), ["self"]))
        }, [
          _createElementVNode("button", {
            class: "lightbox-close",
            type: "button",
            onClick: _cache[8] || (_cache[8] = $event => ($setup.lightbox=[]))
          }, "×"),
          ($setup.lightbox.length>1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "lightbox-prev",
                type: "button",
                onClick: _cache[9] || (_cache[9] = $event => ($setup.lightboxIndex=($setup.lightboxIndex-1+$setup.lightbox.length)%$setup.lightbox.length))
              }, "‹"))
            : _createCommentVNode("v-if", true),
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: $setup.lightbox[$setup.lightboxIndex].src,
              alt: $setup.lightbox[$setup.lightboxIndex].alt
            }, null, 8 /* PROPS */, _hoisted_4),
            _createElementVNode("figcaption", null, [
              _createTextVNode(_toDisplayString($setup.lightbox[$setup.lightboxIndex].alt) + " · " + _toDisplayString($setup.lightboxIndex + 1) + "/" + _toDisplayString($setup.lightbox.length) + " ", 1 /* TEXT */),
              _createElementVNode("a", {
                href: $setup.lightbox[$setup.lightboxIndex].src,
                target: "_blank"
              }, "Открыть оригинал", 8 /* PROPS */, _hoisted_5)
            ])
          ]),
          ($setup.lightbox.length>1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "lightbox-next",
                type: "button",
                onClick: _cache[10] || (_cache[10] = $event => ($setup.lightboxIndex=($setup.lightboxIndex+1)%$setup.lightbox.length))
              }, "›"))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 32 /* NEED_HYDRATION */))
}